import { render, staticRenderFns } from "./AccessRulesModalEdit.vue?vue&type=template&id=5225f948&"
import script from "./AccessRulesModalEdit.vue?vue&type=script&lang=js&"
export * from "./AccessRulesModalEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports